import { render, staticRenderFns } from "./roleSave.vue?vue&type=template&id=ea79651a"
import script from "./roleSave.vue?vue&type=script&lang=js"
export * from "./roleSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports